export default __webpack_public_path__ + "static/Digital-Transformation1-26faa0d123be5eb0cb7e69be93dbcde0.webp";